// extracted by mini-css-extract-plugin
export var applicationHeader = "applicationHeader-module--applicationHeader--ace09";
export var viewingMarker = "applicationHeader-module--viewingMarker--90474";
export var wave = "applicationHeader-module--wave--410e2";